module.exports = __webpack_public_path__ + "img/16a19bf.png";